export default class SectionGroups {
	constructor(elm) {
        this.elm = elm;

        this.nextSibling = this.elm.nextElementSibling;
        if(this.nextSibling) {
            this.setCurve();
        }
	}

	setCurve() {
        if(this.nextSibling.classList.contains('section-group--default')||this.nextSibling.classList.contains('c-footer')) {
            this.elm.classList.add('section-group--curve');
        }
    }
}
